export const MOSTRA_BANNERS = true
export const MOSTRA_PROMOCOES = false
export const MOSTRA_MARCAS = true
export const EMPLOYEES = 'RS Refeições'
export const CLIENTES = 'RS Refeições'
export const NAVIOS = 'RS Refeições'
export const PRECISA_LOGAR = 'Você precisa estar logado para acessar este conteúdo!'
export const CAMINHO_FOTOS = 'http://ftptrade.ddns.net/RSRefeicoes/fotos/'
export const NOME_EMPRESA = 'RS Refeições';
export const CHAVE_EMPRESA = 1;
export const CHAVE_PIX = "599fe42e-2e9a-47ef-91bd-cba37bcef5d4";
export const EMPRESA_CNPJ = "51852220000184";